import StorageInvoiceReGenerate from "./StorageInvoiceReGenerate";

export default StorageInvoiceReGenerate;